import { render, staticRenderFns } from "./comp6.vue?vue&type=template&id=039749f5&scoped=true"
import script from "./comp6.vue?vue&type=script&lang=ts"
export * from "./comp6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039749f5",
  null
  
)

export default component.exports